import { useEffect, useMemo } from 'react';

import { roomTypeQuery, roomTypeService, RoomType } from '@lib/state';
import { useObservable } from './useObservable';

export function useRoomTypeById(roomTypeId: RoomType['id']) {
  useEffect(() => {
    if (!roomTypeQuery.getEntity(roomTypeId)) {
      roomTypeService.getRoomType(roomTypeId);
    }
  }, [roomTypeId]);

  const query = useMemo(() => roomTypeQuery.selectEntity(roomTypeId), [roomTypeId]);
  return useObservable(query, 'async');
}
